<!--
 * @Author: WGL
 * @Date: 2023-06-21 09:23:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-08-26 15:09:11
 * @Description: 
-->
<template>
  <el-dialog
    v-model="dialogVisible"
    append-to-body
    center
    destroy-on-close
    :title="oemCode"
    top="3vh"
    width="45%"
  >
    <el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
      <el-tab-pane
        v-for="(code, index) in codeList"
        :key="index"
        :label="code"
        :name="code"
      />
    </el-tabs>
    <el-table :data="gridData" height="80vh" stripe>
      <el-table-column label="图片" property="image" width="90">
        <template #default="scope">
          <base-image empty-img :src="scope?.row?.image" />
        </template>
      </el-table-column>
      <el-table-column label="标题" property="title" show-overflow-tooltip />
      <el-table-column label="图片地址" property="image" width="200">
        <template #default="scope">
          <a class="omit cp" :href="scope?.row?.image" target="_blank">
            {{ scope?.row?.image }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="来源" property="url" width="220">
        <template #default="scope">
          <a class="omit cp" :href="scope?.row?.url" target="_blank">
            {{ scope?.row?.url }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        v-if="showOpt"
        align="center"
        label="操作"
        property="url"
        width="90"
      >
        <template #default="scope">
          <el-button
            size="small"
            type="primary"
            @click="handleUseImg(scope?.row?.image)"
          >
            应用
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  // 基础产品编码组件
  import { defineComponent, reactive, toRefs } from 'vue'
  import { t } from '@/utils/i18n'
  import { getRequest } from '@/api/api'
  export default defineComponent({
    name: 'BaseOemGoogleSearch',
    components: {},
    props: {
      codeList: { type: Array, default: () => [] },
      showOpt: { type: Boolean, default: false },
    },
    emits: ['use-img'],
    setup(props, { emit }) {
      const state = reactive({
        gridData: [],
        dialogVisible: false,
        oemCode: '',
        activeName: '',
      })
      const handleGoogleSearch = (code) => {
        state.activeName = code
        getRequest('/product/oemCodeGoogleImg', {
          oem_code: code,
        }).then((res) => {
          console.log('res', res)
          state.gridData = res
          state.dialogVisible = true
          state.oemCode = props?.codeList?.length ? '' : code
        })
      }

      const handleClick = (val) => {
        handleGoogleSearch(val)
      }

      const handleUseImg = (url) => {
        emit('use-img', url)
      }
      return {
        ...toRefs(state),
        t,
        handleGoogleSearch,
        handleClick,
        handleUseImg,
      }
    },
  })
</script>

<style lang="scss" scoped></style>
